var _defs, _rect, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1254 1254",
    width: 1254,
    height: 1254,
    role: "img",
    "aria-label": "Task complete",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 23,
    y1: 18,
    x2: 235,
    y2: 1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1F9E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fin",
    x1: 397.21,
    y1: 431,
    x2: 476.79,
    y2: 345.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fout",
    x1: 592.04,
    y1: 938.55,
    x2: 486.28,
    y2: 889.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faint",
    x1: 186,
    y1: 0,
    x2: 365,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8FDC85",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#8FDC85",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FDC85",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d0",
    x1: 186,
    y1: 0,
    x2: 536,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#188D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CBE6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h0",
    x1: 345,
    y1: 0,
    x2: 536,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94E496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F8DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d1",
    x1: 186,
    y1: 0,
    x2: 486,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198B34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68C674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h1",
    x1: 336,
    y1: 0,
    x2: 486,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92DF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5EBD6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 18,
    width: 1206,
    height: 1215,
    rx: 228,
    fill: "url(#card)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speed-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 500,
    width: 350,
    height: 78,
    rx: 39,
    fill: "url(#d0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 500,
    width: 191,
    height: 78,
    rx: 39,
    fill: "url(#h0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 654,
    width: 300,
    height: 78,
    rx: 39,
    fill: "url(#d1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 654,
    width: 150,
    height: 78,
    rx: 39,
    fill: "url(#h1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 812,
    width: 179,
    height: 78,
    rx: 39,
    fill: "url(#faint)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 850,
    r: 37,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ring",
    fill: "none",
    strokeWidth: 84,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.21 431A336 336 0 0 1 476.79 345.66",
    stroke: "url(#fin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.79 345.66A336 336 0 1 1 592.04 938.55",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.04 938.55A336 336 0 0 1 486.28 889.24",
    stroke: "url(#fout)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M568 676L655 753.5L836.5 540",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdif);
export default __webpack_public_path__ + "static/media/odif.171462cfc94f3d41be29d2e199cfc474.svg";
export { ForwardRef as ReactComponent };